import * as React from 'react';

import { randomId } from '@/utils';

type SchemaScriptProps = React.ComponentProps<'script'>;

const SchemaScript = ({
  type = 'application/ld+json',
  id = randomId(),
  ...props
}: SchemaScriptProps) => <script id={id} type={type} {...props} />;

export { SchemaScript };
